import { useEffect, useState } from "react"
import { keyOptions as keywordSuggestions } from "../../SubmitData/InternalFiles/keywordSuggestions";
import { ReactTags } from "react-tag-autocomplete";

export default function KeywordInput(props){
    const [keywordChips, setKeywordChips] = useState([]);

    /**
     * Changes the pre-existing keywords into a format usable by ReactTags on first render.
     */
    useEffect(() => {
      let keywords = []
      props.keywords.forEach(keyword => {
        keywords.push({label: keyword, value: keyword})
      });

      setKeywordChips(keywords)
    }, []);

    function onKeywordTagAddition(item) {
      props.setKeywords((prevState) => {
        return [...prevState, item.value];
      });

      setKeywordChips((prevState) => {
        return [...prevState, item];
      });
    }
      
    function onKeywordTagDelete(item) {
      const keywords = props.keywords.slice(0);
      keywords.splice(item, 1);
      props.setKeywords((prevState) => {
        return [...keywords];
      });

      const chips = keywordChips.slice(0);
      chips.splice(item, 1);
      setKeywordChips((prevState) => {
        return [...chips];
      });
    }

    return(
        <>
        <div className="sm:col-span-6">
        <label
          htmlFor={props.type}
          className="mt-4 block text-base font-medium text-gray-900 dark:text-white"
        >
          {props.type === "Keyword" ?
            "Keywords"
            :
            "Vessels/Labs/Infrastructure Used"
          }
          <span className="text-red-700 font-bold border-red-200">
            *
          </span>
        </label>
        <div data-cy={props.type} className="mt-1 block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md">
          {props.type === "Keyword" ? 
            <ReactTags
              selected={keywordChips}
              suggestions={keywordSuggestions}
              onDelete={onKeywordTagDelete}
              onAdd={onKeywordTagAddition}
              placeholderText={"Add Keyword"}
            />
            :
            <ReactTags
              allowNew
              selected={keywordChips}
              onDelete={onKeywordTagDelete}
              onAdd={onKeywordTagAddition}
              placeholderText={"Add Vessel"}
            />
          }    
        </div>
      </div>
      </>
    )
}